import { fetchJson } from '../utils/fetch';

export const getTdmSearchControlData = async ({ baseUrl, siteId, tdmRuleId }) => {
  const url = `${baseUrl}/independentweb-tdm-search/${siteId}/${tdmRuleId}`;
  const tdmSearchControlData = await fetchJson(url);
  return tdmSearchControlData;
};
